import * as React from 'react';

var UitkSheetContext = React.createContext({
    maxHeight: undefined
});

export { UitkSheetContext as default };
